import { create } from 'zustand';

import { TeachingPlanRepository } from '../../api/repository/teaching-plan';
import type { TeachingPlanForClassNoteParams } from '../../api/repository/teaching-plan';
import type { QltTeachingPlanForClassNote, QltTopicLesson } from '../../api/types';
import { userErrorMessage } from '../userError';

export interface TeachingPlanLessonOption {
  index: string;
  label: string;
  lesson: QltTopicLesson;
}

export interface QltTeachingPlanState {
  plans: QltTeachingPlanForClassNote[];
  lessons: TeachingPlanLessonOption[];
  loading: boolean;
  error: string | null;
  loadForClassNote: (params: TeachingPlanForClassNoteParams) => Promise<TeachingPlanLessonOption[]>;
  reset: () => void;
}

export const useQltTeachingPlanStore = create<QltTeachingPlanState>((set) => ({
  plans: [],
  lessons: [],
  loading: false,
  error: null,

  async loadForClassNote(params) {
    set({ loading: true, error: null });
    try {
      const plans = await TeachingPlanRepository.getForClassNote({ ...params, status: params.status || 'official' });
      const lessons: TeachingPlanLessonOption[] = [];
      let lessonIndex = 1;
      for (let p = 0; p < plans.length; p += 1) {
        for (let t = 0; t < plans[p].topics.length; t += 1) {
          const topic = plans[p].topics[t];
          for (let l = 0; l < topic.lessons.length; l += 1) {
            lessons.push({ index: String(lessonIndex), label: `${topic.name} - ${topic.lessons[l].name}`, lesson: topic.lessons[l] });
            lessonIndex += 1;
          }
        }
      }
      set({ plans, lessons, loading: false });
      return lessons;
    } catch (error) {
      set({ loading: false, error: userErrorMessage(error) });
      return [];
    }
  },

  reset: () => set({ plans: [], lessons: [], error: null }),
}));
